import axios from 'axios';
import { SessionStore } from '../../types/store/SessionStore';
import { newAbortSignal } from '../../utils';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/auth/signoff`;

export const logout = async (): Promise<string> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  return await axios
    .post<string>(
      BASE_URL,
      {},
      {
        headers: {
            'content-type': 'application/json',
            'x-access-token': session?.accessToken,
        },
        timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
        signal:
          AbortSignal.timeout === undefined
            ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
            : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
      }
    )
    .then((response) => response.data);
};